import { cn } from "@/lib/utils";
import React from "react";

export default function OutlineHeading({children, className}:{className?: string, children: React.ReactNode}) {
  return (
    <h3
      className={cn(
        "mb-8 w-full text-2xl lg:text-6xl text-outline font-extrabold text-center uppercase tracking-widest",
        className
      )}
    >
      {children}
    </h3>
  );
}
